import { toast } from "react-toastify";
import { API_BASE_URL, API_ciudadanos } from "../config/apiConfig";
import { generateUniqueFilename } from "./fileUtils";

/**
 * Uploads an image to the specified folder and returns the filename
 * @param {File} file - The image file to upload
 * @param {string} folder - The folder to upload to (e.g., "recursos", "servicios")
 * @returns {Promise<string>} - The unique filename of the uploaded image
 */
export const uploadImage = async (file, folder) => {
  // Validar tipo de archivo
  const tiposPermitidos = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/gif",
    "image/webp",
  ];

  if (!tiposPermitidos.includes(file.type)) {
    throw new Error(
      "Por favor, selecciona un archivo de imagen válido (JPG, PNG, GIF)"
    );
  }

  // Validar tamaño (máximo 5MB)
  if (file.size > 5 * 1024 * 1024) {
    throw new Error("El archivo es demasiado grande. El tamaño máximo es 5MB");
  }

  // Generar nombre único para el archivo
  const uniqueFilename = generateUniqueFilename(file.name);

  // Crear un nuevo archivo con el nombre único
  const renamedFile = new File([file], uniqueFilename, { type: file.type });

  // Crear FormData para la subida
  const formData = new FormData();
  formData.append("file", renamedFile);
  formData.append("folder", folder);
  formData.append("userId", "default");

  try {
    const response = await fetch(`${API_BASE_URL}/downloads/${folder}`, {
      method: "POST",
      headers: {
        Authorization:
          "Bearer 34P7JFEJYDKJSkisUIOwEOUXPEh6zr9zPcI9V599PTtr1Zam04",
      },
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }

    const result = await response.json();
    if (!result.isOk || !result.fileIds?.[0]) {
      throw new Error(result.message || "Error desconocido al subir la imagen");
    }

    return uniqueFilename;
  } catch (error) {
    console.error("Error al subir la imagen:", error);
    throw error;
  }
};

export const uploadImageToCloudinary = async (file, userId, token) => {
  try {
    const formData = new FormData();
    formData.append("image", file);

    const response = await fetch(`${API_ciudadanos}/${userId}/upload-image`, {
      method: "POST",
      headers: {
        "x-auth-token": token,
      },
      body: formData,
    });

    if (response.ok) {
      const data = await response.json();
      return data.imageUrl;
    } else {
      throw new Error("Error al subir la imagen");
    }
  } catch (error) {
    console.error("Error al subir imagen:", error);
    throw error;
  }
};
